let isInit = false,
    completed = false,
    queue = [],
    rAF = -1;

module.exports = {
    NUMBER_OF_FRAMES_TO_WAIT: 30,
    add: function(func){
        if(completed){
            func();
        }else{
            queue.push(func);
        }

        if(isInit) return;
        isInit = true;
        let lastHeight = document.documentElement.scrollHeight,
            count = 0;

        const run = () => {
            let height = document.documentElement.scrollHeight;

            if(lastHeight !== height){
                count = 0;
            }else{
                count++;

                if( count >= this.NUMBER_OF_FRAMES_TO_WAIT){
                    completed = true;
                    queue.forEach(func => func());
                    return;
                }
            }

            lastHeight = height;
            rAF = requestAnimationFrame(run);
        };

        rAF = requestAnimationFrame(run);
    },
    reset(){
        cancelAnimationFrame(rAF);
        isInit = false;
        completed = false;
        queue = [];
    }
};